<template>
  <section class="unit-section" :class="{ 'is-active': isActive }">
    <!-- 배경 이미지 -->
    <div class="bg-layer">
      <img src="@/assets/bg_brand1_250701.jpg" alt="" class="bg-img" />
    </div>

    <!-- BRAND 타이틀 -->
    <h2 class="brand-title">BRAND</h2>

    <!-- 로고 합체 애니메이션 -->
    <div class="brand-logo-wrap" :class="{ 'is-active': isActive }">
      <img src="@/assets/logo/logo_part1.png" alt="" class="brand-logo brand-logo-left" />
      <span class="brand-x">X</span>
      <img src="@/assets/logo/logo_part3.png" alt="" class="brand-logo brand-logo-right" />
    </div>

    <!-- 하단 로고 part4 -->
    <div class="brand-part4-wrap" :class="{ 'is-active': isActive }">
      <img src="@/assets/logo/logo_part4.png" alt="" class="brand-part4" />
    </div>

    <!-- 브랜드 설명 -->
    <div class="brand-desc-wrap" :class="{ 'is-active': isActive }">
      <p class="brand-desc">계룡건설과 한신공영이</p>
      <p class="brand-desc">수원 주거문화의 기준을 새롭게 완성합니다</p>
    </div>

    <!-- + 버튼 -->
    <div class="plus-wrap" :class="{ 'is-active': isActive }" @click="$router.push('/intro/brand')">
      <span class="view-more-text">VIEW MORE</span>
      <div class="plus-btn">
        <span class="plus-icon">+</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UnitSection',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.unit-section {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

/* 로고 합체 */
.brand-logo-wrap {
  position: absolute;
  top: 320px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 24px;
  z-index: 1;
}

.brand-logo {
  height: 80px;
  width: auto;
  transition: opacity 1.2s cubic-bezier(0.16, 1, 0.3, 1), transform 1.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.brand-logo-left {
  opacity: 0;
  transform: translateX(-60px);
}

.brand-logo-right {
  opacity: 0;
  transform: translateX(60px);
}

.brand-x {
  font-family: var(--font-family2);
  font-size: 36px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 2px;
  opacity: 0;
  transition: opacity 0.8s ease 0.6s;
}

.brand-logo-wrap.is-active .brand-logo-left {
  opacity: 1;
  transform: translateX(0);
}

.brand-logo-wrap.is-active .brand-logo-right {
  opacity: 1;
  transform: translateX(0);
}

.brand-logo-wrap.is-active .brand-x {
  opacity: 1;
}

/* 하단 part4 */
.brand-part4-wrap {
  position: absolute;
  top: 430px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.brand-part4 {
  height: 40px;
  width: auto;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 1s cubic-bezier(0.16, 1, 0.3, 1) 0.8s, transform 1s cubic-bezier(0.16, 1, 0.3, 1) 0.8s;
}

.brand-part4-wrap.is-active .brand-part4 {
  opacity: 1;
  transform: translateY(0);
}

/* 브랜드 설명 */
.brand-desc-wrap {
  position: absolute;
  top: 540px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 1;
}

.brand-desc {
  font-family: var(--font-family3);
  font-size: 30px;
  font-weight: 700;
  color: #fff;
  line-height: 1.5;
  letter-spacing: -0.5px;
  opacity: 0;
  transform: translateY(15px);
  transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.brand-desc-wrap.is-active .brand-desc:nth-child(1) {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 1.1s;
}

.brand-desc-wrap.is-active .brand-desc:nth-child(2) {
  opacity: 1;
  transform: translateY(0);
  transition-delay: 1.3s;
}

/* + 버튼 wrap */
.plus-wrap {
  position: absolute;
  bottom: 100px;
  right: 140px;
  display: flex;
  align-items: center;
  z-index: 1;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease 1.5s, transform 0.8s ease 1.5s;
}

.plus-wrap.is-active {
  opacity: 1;
  transform: translateY(0);
}

.view-more-text {
  font-family: var(--font-family2);
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 3px;
  margin-right: -20px;
  z-index: 2;
  position: relative;
  transition: color 0.3s ease;
}

.plus-wrap:hover .view-more-text {
  color: #fff;
}

.plus-btn {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease, border-color 0.3s ease;
}

.plus-wrap:hover .plus-btn {
  background: var(--thehue-primary);
  border-color: var(--thehue-primary);
}

.plus-icon {
  font-family: var(--font-family2);
  font-size: 32px;
  font-weight: 300;
  color: #fff;
  line-height: 1;
  transition: transform 0.3s ease;
}

.plus-btn:hover .plus-icon {
  transform: rotate(90deg);
}

.brand-title {
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translateX(-50%);
  font-family: var(--font-family2);
  font-size: 32px;
  font-weight: 300;
  color: #fff;
  letter-spacing: 10px;
  z-index: 1;
}

.bg-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 모바일 반응형 */
@media (max-width: 768px) {
  .unit-section {
    height: auto;
    min-height: 100svh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 24px 60px;
    overflow: hidden;
  }

  .bg-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .bg-img {
    object-position: center;
  }

  .brand-title {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    font-size: 18px;
    letter-spacing: 6px;
    margin-bottom: 32px;
    z-index: 1;
  }

  .brand-logo-wrap {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    gap: 12px;
    margin-bottom: 20px;
  }

  .brand-logo {
    height: 40px;
  }

  .brand-x {
    font-size: 20px;
  }

  .brand-part4-wrap {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    margin-bottom: 32px;
  }

  .brand-part4 {
    height: 22px;
  }

  .brand-desc-wrap {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    margin-bottom: 40px;
  }

  .brand-desc {
    font-size: 16px;
    word-break: keep-all;
  }

  .plus-wrap {
    position: relative;
    bottom: auto;
    right: auto;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .plus-wrap.is-active {
    transform: translateY(0);
  }

  .view-more-text {
    margin-right: 0;
    font-size: 11px;
    letter-spacing: 2px;
  }

  .plus-btn {
    width: 52px;
    height: 52px;
  }

  .plus-icon {
    font-size: 24px;
  }
}
</style>
